import { IError } from '.'

export interface ISendToState {
  data: string | null
  isLoading: boolean
  error: IError | null
}

export const initialState: ISendToState = {
  data: null,
  isLoading: false,
  error: null,
}
